import { Component, computed, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { OuiCheckbox } from 'omnium-ui/form-field';
import { OuiTagModule } from 'omnium-ui/tag';
import { ConsultantCardComponent } from '../../../../../../core/components/consultant-card/consultant-card.component';
import {
  GedDocument,
  InvestorGedDocuments,
  InvestorPersonCorrectionSuggestionMessageLevel
} from '../../../../../../core/models/api.models';
import { StateCardComponent } from '../../../../shared/state-card/state-card.component';
import { formatDate, formatText } from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-ged-section',
  imports: [
    OuiCheckbox,
    OuiTagModule,
    ConsultantCardComponent,
    StateCardComponent,
    InvestorViewerAccordionComponent
  ],
  templateUrl: './investor-ged-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../investor-viewer-section.shared.scss',
    './investor-ged-section.component.scss'
  ]
})
export class InvestorGedSectionComponent {
  readonly documents = input<InvestorGedDocuments | null>(null);
  readonly loading = input(false);
  readonly error = input<string | null>(null);

  protected readonly formatDate = formatDate;
  protected readonly formatText = formatText;
  protected readonly showInactiveDocuments = signal(false);

  protected readonly visibleDocuments = computed(() => {
    const currentDocuments = this.documents()?.documents ?? [];

    return this.showInactiveDocuments()
      ? currentDocuments
      : currentDocuments.filter(document => document.isActive === true);
  });

  protected getMessageTagStatus(
    level?: InvestorPersonCorrectionSuggestionMessageLevel
  ): 'completed' | 'pending' | 'error' {
    switch (level) {
      case 'error':
        return 'error';
      case 'warning':
        return 'pending';
      default:
        return 'completed';
    }
  }

  protected getDocumentTitle(document: GedDocument): string {
    return document.designation?.trim()
      || document.typeDocumentCode?.trim()
      || document.categoryCode?.trim()
      || `Document ${document.documentId}`;
  }
}
